import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Container, Form, Image } from "react-bootstrap";
import ComponentLoader from "../../layout/ComponentLoader";
import { apiGetOrgunits } from "../../../api/ApiOrgunit";
import {
  MdInfoOutline,
  MdPeople,
  MdOutlineCancel,
  MdOutlineSearch,
  MdFiberNew,
} from "react-icons/md";
import { apiGetPersonnes } from "../../../api/ApiPersonnes";
import PersonneCard from "../personne/PersonneCard";
import { trouveMotDebutantParSearchDansPhrase } from "../../../utils/search";
import iconColidee from "../../../assets/images/tools/icon_colidee.png";
import ComponentTitle from "../../layout/ComponentTitle";
import PersonneCardList from "../personne/PersonneCardList";
import { apiGetProcesses } from "../../../api/ApiProcess";
import {
  apiGetAllContribByUsersByEspaces,
  apiGetLastContribByUsers,
} from "../../../api/ApiColidee";
import { dateDiff, dateJour, toDateParseEN } from "../../../utils/datesHeures";

import {
  BsSortAlphaDown,
  BsSortAlphaUpAlt,
  BsSortNumericDown,
  BsSortNumericUp,
} from "react-icons/bs";

const BlocSousOrgunit = (props) => {
  const { t } = useTranslation();
  const { orgunitParent } = props;
  const [loader, setLoader] = useState(false);
  const [activeInterne, setActiveInterne] = useState(true);
  const [activeExterne, setActiveExterne] = useState(true);
  const [search, setSearch] = useState("");
  const [infoView, setInfoView] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [contributions, setContributions] = useState([]);
  const [allContributions, setAllContributions] = useState([]);
  const [seeOnlyNewOrgUnits, setSeeOnlyNewOrgUnits] = useState(false);
  const [triBy, setTriBy] = useState("nomAsc");

  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);

  const [orgunitsCopy, setOrgunitsCopy] = useState([]);
  const [orgunits, setOrgunits] = useState([]);
  const [personnes, setPersonnes] = useState([]);
  const [personnesCopy, setPersonnesCopy] = useState([]);
  const [orgunitSelected, setOrgunitSelected] = useState("");

  // on recupere toutes les personnes de la BDD
  const recupPersonnes = async () => {
    const res = await apiGetPersonnes(
      ReduxInstance._id,
      "include=marque,localisations,orgUnitsParent"
    );
    res.data.forEach((personne) => {
      personne.orgUnitsParentIdToArray = [];
      personne.orgUnitsParent.forEach((orgUnit) => {
        personne.orgUnitsParentIdToArray.push(orgUnit._id);
      });
    });
    setPersonnes(res.data);

    if (infoView === true) {
      if (ReduxInstance.espacePrincipalColidee !== 0) {
        recupContributions(res.data);
      }
      recupAllContributionsForUsersOnAllEspaces(res.data);
    }
  };

  // on recupere tous les orgunit de la BDD ayant un chap orgunitparent contenant celui de la props
  const recupOrgUnits = async () => {
    setLoader(true);

    const res = await apiGetOrgunits(ReduxInstance._id, "filter[orgUnitParent]=" + orgunitParent);
    let orgunitsOrigine = res.data;
    orgunitsOrigine.map((item, index) => (item.nbPersonnes = nbrPersonnesInOrgunit(item._id)));

    setOrgunits(orgunitsOrigine.filter((item) => item.enSommeil !== true));
    setOrgunitsCopy(orgunitsOrigine.filter((item) => item.enSommeil !== true));

    setLoader(false);
  };

  // si on clique  sur le bouton  MdPeople sur chaque ligne orgunit
  const filtrePersonnesInOrgunit = (orgunitID) => {
    // on change de filtre ou on fait un toggle si on reclique sur le meme, sert aussi au fond jaune sur l'icone
    if (orgunitID === orgunitSelected) {
      setOrgunitSelected("");
    } else {
      setOrgunitSelected(orgunitID);
    }
  };

  // permet d'afficher les personnes en dessous en fonction des 4 critères demandées (scope, recherche et clic sur MdPeople)
  const afficheListPersonnes = async (orgunitFiltreGroup) => {
    // on met dans un tableau les ID des orgunit affichés
    const orgunitsIdInList = [];
    orgunitsCopy.forEach((orgunit) => orgunitsIdInList.push(orgunit._id));

    // pour chaque personne on controle si :
    // elle a un orgUnitsParent comportant la valeur du bouton MdPeople,
    // sinon si elle a orgUnitsParent en commun avec les orgunitsIdInList dans le cas du scope ou de la recherche.
    let personnesFiltrees = [];

    if (orgunitFiltreGroup) {
      personnesFiltrees = personnes.filter((personne) =>
        personne.orgUnitsParentIdToArray.includes(orgunitFiltreGroup)
      );
    } else {
      personnes.forEach((personne) => {
        let intersection = orgunitsIdInList.filter((x) =>
          personne.orgUnitsParentIdToArray.includes(x)
        );
        if (intersection.length) personnesFiltrees.push(personne);
      });
    }
    // on met à jour les personnes filtrées en dessous
    setPersonnesCopy(personnesFiltrees);
  };

  const cancelFiltres = () => {
    setShowSearch(false);
    setActiveExterne(true);
    setActiveInterne(true);
    setSeeOnlyNewOrgUnits(false);
    setSearch("");
    setOrgunitSelected("");
  };

  const nbrPersonnesInOrgunit = (idOrgunit) => {
    const personnesFiltrees = personnes.filter((personne) =>
      personne.orgUnitsParentIdToArray.includes(idOrgunit)
    );
    return personnesFiltrees.length;
  };

  useEffect(() => {
    let orgUnitsFiltres = [...orgunits];
    let orgUnitsInternes = [];
    let orgUnitsExternes = [];

    if (seeOnlyNewOrgUnits) {
      orgUnitsFiltres = orgUnitsFiltres.filter(
        (orgunit) => tagNew(orgunit.createdAt) < 15 || tagNew(orgunit.updatedAt) < 15
      );
    }

    if (activeInterne) {
      orgUnitsInternes = orgUnitsFiltres.filter((orgunit) => orgunit.scope === "Interne");
    }

    if (activeExterne) {
      orgUnitsExternes = orgUnitsFiltres.filter((orgunit) => orgunit.scope === "Externe");
    }

    orgUnitsFiltres = orgUnitsInternes.concat(orgUnitsExternes);

    if (search) {
      let orgunitsStartWith = [];
      orgUnitsFiltres.forEach((orgunit) => {
        if (trouveMotDebutantParSearchDansPhrase(search, orgunit)) {
          orgunitsStartWith.push(orgunit);
        }
      });
      orgUnitsFiltres = orgunitsStartWith;
    }

    if (triBy === "nomAsc")
      orgUnitsFiltres.sort((a, b) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0));
    if (triBy === "nomDesc")
      orgUnitsFiltres.sort((b, a) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0));
    if (triBy === "nbPersonnesAsc")
      orgUnitsFiltres.sort((a, b) =>
        a.nbPersonnes > b.nbPersonnes ? 1 : b.nbPersonnes > a.nbPersonnes ? -1 : 0
      );
    if (triBy === "nbPersonnesDesc")
      orgUnitsFiltres.sort((b, a) =>
        a.nbPersonnes > b.nbPersonnes ? 1 : b.nbPersonnes > a.nbPersonnes ? -1 : 0
      );

    setOrgunitsCopy(orgUnitsFiltres);
  }, [search, activeInterne, activeExterne, orgunitSelected, seeOnlyNewOrgUnits, triBy]); // eslint-disable-line react-hooks/exhaustive-deps

  const titreAdapte = () => {
    let phrase =
      personnesCopy.length > 0
        ? personnesCopy.length
        : t("public.pageInSocial.titleFilterPersonnesAucun");
    phrase += " ";
    phrase +=
      personnesCopy.length > 1
        ? t("public.pageInSocial.titleFilterPersonnesPluriel")
        : t("public.pageInSocial.titleFilterPersonnesSingulier");

    return phrase;
  };

  const toggleEtatBoutons = (bouton, etatActiveInterne, etatActiveExterne) => {
    // cas du bouton Interne
    if (bouton === "interne") {
      // si les 2 boutons sont actifs ==> etat de chargement de la page a l'arrivee, on active que l'interne
      if (etatActiveInterne && etatActiveExterne) {
        setActiveInterne(true);
        setActiveExterne(false);
      }
      // si interne est coché et pas externe ==> on veut revenir à l'etat initial
      if (etatActiveInterne && !etatActiveExterne) {
        setActiveInterne(true);
        setActiveExterne(true);
      }
      // si interne pas coche et externe coche on veut toggle entre interne et externe
      if (!etatActiveInterne && etatActiveExterne) {
        setActiveInterne(true);
        setActiveExterne(false);
      }
    }

    if (bouton === "externe") {
      // si les 2 boutons sont actifs ==> etat de chargement de la page a l'arrivee, on active que l'externe
      if (etatActiveInterne && etatActiveExterne) {
        setActiveInterne(false);
        setActiveExterne(true);
      }
      // si externe est coché et pas interne ==> on veut revenir à l'etat initial
      if (!etatActiveInterne && etatActiveExterne) {
        setActiveInterne(true);
        setActiveExterne(true);
      }
      // si externe pas coche et interne coche on veut toggle entre externe et interne
      if (etatActiveInterne && !etatActiveExterne) {
        setActiveInterne(false);
        setActiveExterne(true);
      }
    }
  };

  const recupContributions = async (personnesArray) => {
    if (ReduxInstance.espacePrincipalColidee) {
      const myForm = new FormData();
      myForm.append("espacePrincipalColidee", ReduxInstance.espacePrincipalColidee);
      personnesArray.forEach((element) => {
        myForm.append("email[]", element.email);
      });

      const res = await apiGetLastContribByUsers(ReduxToken, myForm);
      if (res.data) {
        personnesArray.forEach((element) => {
          let personneFound = res.data.findIndex(function (personneColidee) {
            if (personneColidee.email === element.email) {
              return true;
            }
            return false;
          });
          if (personneFound === -1) {
            res.data.push({
              email: element.email,
              contribution: "Non renseigné",
            });
          }
        });

        setContributions(res.data);
      } else {
        console.log("error");
      }
    }
  };

  const recupAllContributionsForUsersOnAllEspaces = async (personnesArray) => {
    const myForm = new FormData();

    personnesArray.forEach((element) => {
      myForm.append("email[]", element.email);
    });

    var espacesSouhaites = [];
    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces))
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);
    /* Si j'ai un espace RDV missions alors je ne le prends pas en compte pour trouver la derniere contrib sur tous les espaces */
    if (ReduxInstance.espacePrincipalColidee !== 0) {
      espacesSouhaites = espacesSouhaites.filter(
        (item) => parseInt(item) !== parseInt(ReduxInstance.espacePrincipalColidee)
      );
    }

    if (espacesSouhaites.length) {
      myForm.append("espacesSouhaites", espacesSouhaites.join(","));
      const resAllContributions = await apiGetAllContribByUsersByEspaces(ReduxToken, myForm);

      if (resAllContributions.data) {
        personnesArray.forEach((element) => {
          let personneFound = resAllContributions.data.findIndex(function (personneColidee) {
            if (personneColidee.email === element.email) {
              return true;
            }
            return false;
          });
          if (personneFound === -1) {
            resAllContributions.data.push({
              email: element.email,
              contribution: "Non renseigné",
            });
          }
        });

        setAllContributions(resAllContributions.data);
      } else {
        console.log("error");
      }
    }
  };

  const hasOrgunitInterne = () => {
    const newArray = orgunitsCopy.filter((orgunit) => orgunit.scope === "Interne");
    return newArray.length;
  };

  const hasOrgunitExterne = () => {
    const newArray = orgunitsCopy.filter((orgunit) => orgunit.scope === "Externe");
    return newArray.length;
  };

  const hasNewOrgunits = () => {
    const newArray = orgunitsCopy.filter(
      (orgunit) => tagNew(orgunit.createdAt) < 15 || tagNew(orgunit.updatedAt) < 15
    );
    return newArray.length;
  };

  const tagNew = (orgunitDateCreation) => {
    if (orgunitDateCreation) {
      let diff = dateDiff(toDateParseEN(orgunitDateCreation), dateJour());
      return diff.day;
    }
  };

  // lance à chaque changement de orgunitsCopy ou orgunitSelected (en gros lors d'un filtre interne, extener, tous, recherche ou clic sur bouton MdPeople)
  useEffect(() => {
    afficheListPersonnes(orgunitSelected);
  }, [orgunitsCopy, orgunitSelected]); // eslint-disable-line react-hooks/exhaustive-deps

  // lance a la verification de l'existence ou non du orgunit prevu (au cas ou il ait ete supprime)
  // on cherche les personnes en premier avant de lancer la recherche des orgunit sur le useEffect sinon on peut pâs calculer le Nbr de personnes dans le groupe
  useEffect(() => {
    if (orgunitParent) {
      recupPersonnes();
    }
  }, [orgunitParent, infoView]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (orgunitParent) {
      recupOrgUnits();
    }
  }, [personnes, infoView]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loader && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}
      {!loader && (
        <Container fluid className="mt-1 mb-1">
          {orgunitParent && orgunits.length > 0 && (
            <>
              <ComponentTitle title={t("public.componentOrgUnit.instances")} emulateH2="true" />
              <Container
                fluid
                className="mb-3 d-flex  align-items-center flex-wrap containerFiltresSousOrgUnit"
              >
                {hasOrgunitInterne() > 0 && (
                  <div className="m-1  align-items-center d-flex">
                    <Form.Check
                      className={activeInterne && !activeExterne ? "filtreActif" : "filtreNonActif"}
                      type="checkbox"
                      label={t("public.filtres.filtre15")}
                      id="interne"
                      name="Interne"
                      onChange={(e) => {
                        toggleEtatBoutons("interne", activeInterne, activeExterne);
                      }}
                      checked={activeInterne ? "checked" : ""}
                      disabled={orgunitSelected ? "disabled" : ""}
                    />
                  </div>
                )}
                {hasOrgunitExterne() > 0 && (
                  <div className="m-1 align-items-center d-flex">
                    <Form.Check
                      className={!activeInterne && activeExterne ? "filtreActif" : "filtreNonActif"}
                      type="checkbox"
                      label={t("public.filtres.filtre16")}
                      id="externe"
                      name="Externe"
                      onChange={(e) => {
                        toggleEtatBoutons("externe", activeInterne, activeExterne);
                      }}
                      checked={activeExterne ? "checked" : ""}
                      disabled={orgunitSelected ? "disabled" : ""}
                    />
                  </div>
                )}
                {hasNewOrgunits() > 0 && (
                  <div
                    className={
                      seeOnlyNewOrgUnits
                        ? "d-flex m-2 align-items-center d-flex m-2 align-items-center filtreActif"
                        : "d-flex m-2 align-items-center"
                    }
                  >
                    <MdFiberNew
                      size="2em"
                      role="button"
                      onClick={(e) => setSeeOnlyNewOrgUnits(!seeOnlyNewOrgUnits)}
                    />
                  </div>
                )}

                <BsSortAlphaDown
                  size="1.6em"
                  onClick={(e) => setTriBy("nomAsc")}
                  role="button"
                  className={triBy == "nomAsc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />

                <BsSortAlphaUpAlt
                  size="1.6em"
                  onClick={(e) => setTriBy("nomDesc")}
                  role="button"
                  className={triBy == "nomDesc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />
                <BsSortNumericDown
                  size="1.6em"
                  onClick={(e) => setTriBy("nbPersonnesAsc")}
                  role="button"
                  className={triBy == "nbPersonnesAsc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />
                <BsSortNumericUp
                  size="1.6em"
                  onClick={(e) => setTriBy("nbPersonnesDesc")}
                  role="button"
                  className={triBy == "nbPersonnesDesc" ? "m-1 filtreActif" : "m-1 filtreNonActif"}
                />

                <div className="m-1 p-1 align-items-center d-flex border">
                  <MdOutlineSearch
                    size="1.6em"
                    onClick={(e) => setShowSearch(!showSearch)}
                    role="button"
                  />
                  {showSearch && (
                    <Form.Control
                      type="text"
                      placeholder="Rechercher"
                      size="50"
                      name="search"
                      value={search}
                      className="border-0 form-control-sm"
                      onChange={(e) => setSearch(e.target.value)}
                      disabled={orgunitSelected ? "disabled" : ""}
                    />
                  )}
                </div>
                {(search || !activeInterne || !activeExterne || seeOnlyNewOrgUnits) &&
                  !orgunitSelected && (
                    <div className="d-flex m-2 align-items-center  ">
                      <MdOutlineCancel
                        size="1.5em"
                        role="button"
                        onClick={() => cancelFiltres()}
                        className="ms-2 text-danger"
                      />
                    </div>
                  )}
              </Container>
              <div className="containerOrgUnitsInOperation p-2">
                {orgunitsCopy.map((orgunit, index) => (
                  <div
                    className="orgUnitInOperation p-1 d-flex align-items-center"
                    key={orgunit._id}
                  >
                    {(tagNew(orgunit.createdAt) < 15 || tagNew(orgunit.updatedAt) < 15) && (
                      <MdFiberNew size="2em" role="button" className="iconNewOrgUnit" />
                    )}
                    <span className="flex-grow-1">{orgunit.nom}</span>
                    <span className="d-flex flex-nowrap align-items-center">
                      <span className="me-1">
                        {orgunit.liens
                          .filter((lien) => lien.icone === "colidee")
                          .map((lien, index) => (
                            <a
                              href={lien.url}
                              target="_blank"
                              rel="noreferrer"
                              key={"lienColidee_" + index}
                            >
                              <Image src={iconColidee} className="ms-2 me-2" />
                            </a>
                          ))}
                      </span>
                      <span
                        className={
                          orgunitSelected === orgunit._id
                            ? "nbrPersonnesInOrgunit d-flex flex-nowrap align-items-center ps-2 pe-2 selectedGroup"
                            : "nbrPersonnesInOrgunit d-flex flex-nowrap align-items-center ps-2 pe-2"
                        }
                      >
                        <span className="me-1">{orgunit.nbPersonnes}</span>
                        <MdPeople
                          size="1.5em"
                          role="button"
                          onClick={(e) => filtrePersonnesInOrgunit(orgunit._id)}
                        />
                      </span>
                      <Link to={`/orgunits/${orgunit._id}`}>
                        <MdInfoOutline size="2em" role="button" className="float-end " />
                      </Link>
                    </span>
                  </div>
                ))}
              </div>
              <br />
              {personnesCopy.length > 0 && (
                <>
                  <ComponentTitle
                    title={titreAdapte()}
                    overflowID={"overflowSousMembres"}
                    infoView={infoView}
                    setInfoView={setInfoView}
                    afficheBoutonGrille="true"
                    emulateH2="true"
                  />
                  <div className="d-flex overflowContent" id={"overflowSousMembres"}>
                    {!infoView &&
                      personnesCopy.map((personne, key) => (
                        <PersonneCard personne={personne} key={personne._id} />
                      ))}

                    {infoView && (
                      <PersonneCardList
                        personnes={personnesCopy}
                        infoView={infoView}
                        contributions={contributions}
                        allContributions={allContributions}
                      />
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </Container>
      )}
    </>
  );
};

export default BlocSousOrgunit;
